<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";
    const orderStore = useOrderStore();

    const r$ = orderStore.validation.r$;
</script>
<template>
    <checkout-order-selection-service
        v-if="orderStore.options.configuration.mode === 'SERVICE'"
    />
    <checkout-order-selection-product v-else />
    <template v-if="r$.$fields.products.$error">
        <VAlert type="error" class="mb-2" density="compact">
            {{ r$.$fields.products.$self.$errors[0] }}
        </VAlert>
    </template>
    <VAlert
        v-if="orderStore.meta.timeslotAvailabilityError === 1"
        type="error"
        class="mt-2 mb-4"
        density="compact"
    >
        {{ $t("checkout.product.noInventory") }}
    </VAlert>
</template>
